import { DIALOG_TYPE, LayoutConfig } from '@spartacus/storefront'
import { CancelDispenserAgreementModalComponent } from './cancel-dispenser-agreement-modal.component'

export const cancelDispenserAgreementLayoutConfig: LayoutConfig = {
  launch: {
    CANCEL_DISPENSER_AGREEMENT: {
      inlineRoot: true,
      component: CancelDispenserAgreementModalComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
}
